import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import md5 from 'md5';

import CloseIcon from '@material-ui/icons/Cancel';

import NavigateBefore from '@material-ui/icons/NavigateBefore';
import NavigateAfter from '@material-ui/icons/NavigateNext';

import Loading from '../../../dialogs/loading';
import Error from '../../../dialogs/Error';

import { ProcessIcon, FilterIcon } from '../../../../images/icons/WrapSvg';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/process.home.actions';
import * as actionsvisibility from '../../../../actions/visibility.actions';
import * as actionslocals from '../../../../actions/locals.actions';

import { formatDate } from '../../../../functions/time';

import Family from './Family';
import FilterMenu from './FilterMenu';


// eslint-disable-next-line
import style from './_styles.css';

function toolbar(handleFilter, nofiltered) {
    const aux = [];
    aux.push(
        <FilterIcon
            disabled
            key={'hide-menu-toolbar'}
            color={nofiltered ? 'primary' : 'secondary'}
            onClick={handleFilter}
        />,
    );
    return aux;
}

class Index extends React.Component {

    state = {
        open: false,
        options: [1, 2, 3, 4, 5, 6]
    }

    componentDidMount() {
        const tools = [toolbar(this.handleFilter, true)];
        this.props.setTools(tools);
    }

    componentWillUnmount() {
        this.props.setTools([]);
    }

    handleFilter = (event) => {
        this.setState({ open: true });
    }

    handleSearch = (date) => {
        const { visibility } = this.props;
        this.props
                .loadVisibility(visibility.local, date)
                .catch((error) => {
                    this.setState({ error: error.message });
                });
    }

    handleCloseFilter = (options) => {
        this.setState({ open: false, options: options });
        const tools = [toolbar(this.handleFilter, options && options.length === 6)];
        this.props.setTools(tools);
    }

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(false);
    }

    handleTooltipOpen = (family, i) => (event) => {

        const message =
            <div className="flex_full_row popup bg_golden_yellow c_white padding_borders border_radius_6 center">
                <div className="flex_auto_row center ">
                    <CloseIcon className="hand margin_right_12" onClick={this.handleTooltipClose} />
                </div>
                <div className="flex_full_column">
                    {i.creada &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'visibility_init' })}
                            {': '}
                            {i.creada}
                        </div>
                    }
                    {i.cerrada &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'visibility_ended' })}
                            {': '}
                            {i.cerrada}
                        </div>
                    }
                    {i.cerradaPor &&
                        <div className="flex_full_row nowrap barlow_regular_smalltext margin_top_4 margin_left_2">
                            {this.props.intl.formatMessage({ id: 'user' })}
                            {': '}
                            {i.cerradaPor}
                        </div>
                    }
                </div>
                {i.accesible &&
                    <div className="flex_auto_row center margin_left_12">
                        <ProcessIcon className="hand" onClick={(event) => this.handerClick(md5(family), i.proceso, i.idInstancia)} />
                    </div>
                }
            </div>

        const intervalId = setInterval(this.timer, 10000);
        this.setState({ intervalId: intervalId, message: message });
    }

    handleTooltipClose = (event) => {
        this.setState({ message: undefined });
    }

    timer = () => {
        clearInterval(this.state.intervalId);
        this.setState({ message: undefined });
    }

    handerClick = (family, process, id) => {
        this.props.history.push(`/processes/${family}/${process}/${id}`)
    }

    render() {
        const { info, visibility, visibility_is_loading, visibility_has_errored } = this.props;
        const { message, open, options } = this.state;

        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '20' || f === '82') &&
              info.security.licencias.some((f) => f.id === 150 && f.activo ))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        }
        else if (visibility_has_errored && visibility_has_errored.hasErrored) {
            return <Error open type={visibility_has_errored.hasErrored}  message={visibility_has_errored.error} handleClose={this.handleBack} />;
        } else {

            let previous = undefined; 
            let next = undefined;
            if( visibility && visibility.data && visibility.data.referencia) {
                const currentDate = new Date(visibility.data.referencia.split(" ")[0]);
                previous = formatDate(new Date().setTime(currentDate.getTime() - (24*60*60*1000)));
                next = formatDate(new Date().setTime(currentDate.getTime() + (24*60*60*1000)));
            }
            return (
                <div onScroll={this.handleScroll} className={'flex_full bg_cloudy_blue_30  overflow_x_scroll showbar'}>
                    {visibility_is_loading  && <Loading open opacity />}
                    <div className="flex_full_colum padding_borders">
                        {(visibility && visibility.data) &&
                            <div className="flex_full_row margin_top_32 margin_bottom_24 align_baseline">
                                {!!previous && 
                                    <div className="flex_full_row align_center hand" onClick={() => this.handleSearch(previous)}> 
                                        <NavigateBefore />
                                        <span className="c_slate margin_left_12 barlow_regular_message nowrap">{previous}</span>
                                    </div>
                                 }
                                <span className="c_slate barlow_semibold nowrap">{visibility.data.local}</span>
                                <span className="c_slate margin_left_12 barlow_regular_message nowrap">{visibility.from}</span>
                                {!!next &&  
                                    <div className="flex_full_row elements_from_right align_center hand" onClick={() => this.handleSearch(next)}>
                                        <span className="c_slate margin_left_12 barlow_regular_message  nowrap">{next}</span> 
                                        <NavigateAfter />
                                    </div>
                                }
                            </div>
                        }
                        {(visibility && visibility.data && visibility.data.familias && visibility.data.familias.length > 0) &&
                            visibility.data.familias
                                .sort((a, b) => a.familia.toUpperCase() > b.familia.toUpperCase() ? 1 : -1)
                                .map((family) =>
                                    <Family {...this.props} key={randomstring()} family={family} options={options} onClick={this.handleTooltipOpen} />
                                )
                        }
                    </div>
                    {message}
                    {open &&
                        <FilterMenu {...this.props} options={options} onClose={this.handleCloseFilter} />
                    }
                </div>
            );
        }
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
}

const mapStateToProps = (state) => {
    return {
        info: state.info,
        locals: state.locals,
        visibility: state.visibility,
        visibility_is_loading: state.visibility_is_loading,
        visibility_has_errored: state.visibility_has_errored
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        Object.assign({}, actions, actionsvisibility, actionslocals),
        dispatch,
    );
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(injectIntl(Index)));



// WEBPACK FOOTER //
// ./src/components/complex/reports/visibility/Index.js